import { AuthProvider, useAuthContext } from './AuthContext';
import { ClientProvider, useClientContext } from './ClientContext';

export const UserProvider = ({ children }) => {
  return (
    <AuthProvider>
      <ClientProvider>
        {children}
      </ClientProvider>
    </AuthProvider>
  );
};

export const useUserContext = () => {
  const { user, setUser, isLoading: authLoading, error: authError } = useAuthContext();
  const { clientId, client, profile, isLoading: clientLoading, error: clientError } = useClientContext();

  return {
    user,
    clientId,
    client,
    isLoading: authLoading || clientLoading,
    error: authError || clientError,
    setUser,
    profile,
  };
};

export const useProfileContext = () => {
  const { profile } = useClientContext();
  return profile;
};

// Re-export focused hooks for new consumers
export { useAuthContext } from './AuthContext';
export { useClientContext } from './ClientContext';
